import {
  completionYMs,
  estatePriceMax,
  estatePriceMin,
  roomsMax,
  roomsMin,
  squareAreaOfMansionMax,
  squareAreaOfMansionMin,
  tsuboAreaMax,
  tsuboAreaMin
} from "common/consts/estates";
import { BldConditionSelection } from "common/interfaces/BldConditionSelection";
import { EstateFilterConditions } from "common/interfaces/EstateFilterConditions";
import { EstateType } from "common/interfaces/EstateType";
import { PurposeSummaryB } from "common/interfaces/PurposeSummaryB";
import { StructureSummary } from "common/interfaces/StructureSummary";
import { DefaultCondition } from "graphql/API";

export const buildFilterConditionsOfDefaultCondition = (
  newFilterConditions: EstateFilterConditions,
  defaultConditions: {
    estateTypes: EstateType[];
    bldConditionSelections: BldConditionSelection[];
    structureSummaries: StructureSummary[];
    purposeSummaryBs: PurposeSummaryB[];
  }
): DefaultCondition => {
  const builtDefaultCondition: DefaultCondition = {
    __typename: "DefaultCondition"
  };

  if (
    (newFilterConditions.estateTypes &&
      newFilterConditions.estateTypes.length ===
        defaultConditions.estateTypes.length &&
      defaultConditions.estateTypes
        .map((x) => x.id)
        .every((x) =>
          newFilterConditions.estateTypes!.map((x) => x?.id).includes(x)
        )) === false
  ) {
    builtDefaultCondition.estateTypes = newFilterConditions.estateTypes.map(
      (x) => x.name ?? null
    );
  }

  if (
    (newFilterConditions.bldConditionSelections &&
      newFilterConditions.bldConditionSelections.length ===
        defaultConditions.bldConditionSelections.length &&
      defaultConditions.bldConditionSelections
        .map((x) => x.id)
        .every((x) =>
          newFilterConditions
            .bldConditionSelections!.map((x) => x?.id)
            .includes(x)
        )) === false
  ) {
    builtDefaultCondition.bldConditionSelections =
      newFilterConditions.bldConditionSelections.map((x) => x.name ?? null);
  }

  if (
    newFilterConditions.structureSummaries.length !==
    defaultConditions.structureSummaries.length
  ) {
    builtDefaultCondition.structureSummaries =
      newFilterConditions.structureSummaries.map((x) => x.name ?? null);
  }

  if (
    newFilterConditions.purposeSummaryBs.length !==
    defaultConditions.purposeSummaryBs.length
  ) {
    builtDefaultCondition.purposeSummaryBs =
      newFilterConditions.purposeSummaryBs.map((x) => x.name ?? null);
  }

  if (newFilterConditions.companyRecNo !== 0) {
    builtDefaultCondition.companyRecNo = newFilterConditions.companyRecNo;
  }

  if (newFilterConditions.tsuboAreaFrom !== tsuboAreaMin) {
    builtDefaultCondition.tsuboAreaFrom = newFilterConditions.tsuboAreaFrom;
  }

  if (newFilterConditions.tsuboAreaTo !== tsuboAreaMax) {
    builtDefaultCondition.tsuboAreaTo = newFilterConditions.tsuboAreaTo;
  }

  if (newFilterConditions.squareAreaOfMansionFrom !== squareAreaOfMansionMin) {
    builtDefaultCondition.squareAreaOfMansionFrom =
      newFilterConditions.squareAreaOfMansionFrom;
  }

  if (newFilterConditions.squareAreaOfMansionTo !== squareAreaOfMansionMax) {
    builtDefaultCondition.squareAreaOfMansionTo =
      newFilterConditions.squareAreaOfMansionTo;
  }

  if (newFilterConditions.estatePriceFrom !== estatePriceMin) {
    builtDefaultCondition.estatePriceFrom = newFilterConditions.estatePriceFrom;
  }

  if (newFilterConditions.estatePriceTo !== estatePriceMax) {
    builtDefaultCondition.estatePriceTo = newFilterConditions.estatePriceTo;
  }

  // if (newFilterConditions.alsoCreatedAtFrom !== dateMin) {
  //   builtDefaultCondition.alsoCreatedAtFrom = Math.trunc(
  //     newFilterConditions.alsoCreatedAtFrom / 1000
  //   );
  // }

  // if (newFilterConditions.alsoCreatedAtTo !== dateMax) {
  //   builtDefaultCondition.alsoCreatedAtTo = Math.trunc(
  //     newFilterConditions.alsoCreatedAtTo / 1000
  //   );
  // }

  // if (newFilterConditions.alsoPricedAtFrom !== dateMin) {
  //   builtDefaultCondition.alsoPricedAtFrom = Math.trunc(
  //     newFilterConditions.alsoPricedAtFrom / 1000
  //   );
  // }

  // if (newFilterConditions.alsoPricedAtTo !== dateMax) {
  //   builtDefaultCondition.alsoPricedAtTo = Math.trunc(
  //     newFilterConditions.alsoPricedAtTo / 1000
  //   );
  // }

  if (
    newFilterConditions.completionYMFrom !==
    completionYMs[completionYMs.length - 1]
  ) {
    builtDefaultCondition.completionYMFrom =
      newFilterConditions.completionYMFrom;
  }

  if (newFilterConditions.completionYMTo !== completionYMs[0]) {
    builtDefaultCondition.completionYMTo = newFilterConditions.completionYMTo;
  }

  if (newFilterConditions.petOk !== false) {
    builtDefaultCondition.petOk = newFilterConditions.petOk;
  }

  if (newFilterConditions.flat !== false) {
    builtDefaultCondition.flat = newFilterConditions.flat;
  }

  if (newFilterConditions.forRent !== false) {
    builtDefaultCondition.forRent = newFilterConditions.forRent;
  }

  if (newFilterConditions.exceptForRent !== false) {
    builtDefaultCondition.exceptForRent = newFilterConditions.exceptForRent;
  }

  if (newFilterConditions.venderOnly !== false) {
    builtDefaultCondition.venderOnly = newFilterConditions.venderOnly;
  }

  if (newFilterConditions.roomsFrom !== roomsMin) {
    builtDefaultCondition.roomsFrom = newFilterConditions.roomsFrom;
  }

  if (newFilterConditions.roomsTo !== roomsMax) {
    builtDefaultCondition.roomsTo = newFilterConditions.roomsTo;
  }

  return builtDefaultCondition;
};
